import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=17bc1051&scoped=true"
import script from "./passwordReset.vue?vue&type=script&lang=js"
export * from "./passwordReset.vue?vue&type=script&lang=js"
import style0 from "./passwordReset.vue?vue&type=style&index=0&id=17bc1051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc1051",
  null
  
)

export default component.exports